function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const StyledTextAlign = styled.span.withConfig({
  displayName: "TextAlign__StyledTextAlign",
  componentId: "sc-1wk93y8-0"
})(["position:relative;display:", ";text-align:", ";"], x => x.block ? 'block' : 'inline-block', x => x.align).withComponent((_ref) => {
  let {
    align,
    block
  } = _ref,
      domProps = _objectWithoutProperties(_ref, ["align", "block"]);

  return /*#__PURE__*/React.createElement("span", domProps);
});
export const TextAlign = (_ref2) => {
  let {
    align,
    block,
    children
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["align", "block", "children"]);

  return /*#__PURE__*/React.createElement(StyledTextAlign, _extends({
    align: align,
    block: block
  }, props), children);
};
export const Left = (_ref3) => {
  let {
    children
  } = _ref3,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(TextAlign, _extends({
    align: "left"
  }, props), children);
};
export const Center = (_ref4) => {
  let {
    children
  } = _ref4,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(TextAlign, _extends({
    align: "center"
  }, props), children);
};
export const Justify = (_ref5) => {
  let {
    children
  } = _ref5,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(TextAlign, _extends({
    align: "justify"
  }, props), children);
};
export const Right = (_ref6) => {
  let {
    children
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(TextAlign, _extends({
    align: "right"
  }, props), children);
};
TextAlign.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify']).isRequired,
  block: PropTypes.bool,
  children: PropTypes.node.isRequired
};
export default TextAlign;